// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"481":"1c9dcfb0","506":"bbad817a","972":"bd0dc895"}[chunkId] + ".chunk.css";
};